import { render, staticRenderFns } from "./BrandComponentProviderComponent.vue?vue&type=template&id=426046d8&scoped=true"
import script from "./BrandComponentProviderComponent.vue?vue&type=script&lang=js"
export * from "./BrandComponentProviderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426046d8",
  null
  
)

export default component.exports